import React, { useRef, useState } from "react";
import { motion } from "framer-motion/dist/framer-motion";
import {
    resetUsersForChannelSelection,
    setChannelCreation,
    setSingleUserForChannelSelection
} from "../../../redux/slices";
import Icon from "../../../components/Icon";
import ContactsSearch from "./ContactsSearch/ContactsSearch";
import { useTypedDispatch, useTypedSelector } from "../../../redux/hooks";
import { usePolyglot } from "../../../context/Polyglot";
import { ChatSettingsSidebarMenus } from "./index";
import styles from './styles.module.scss';
import { StyledButton } from "../../../components/StyledComponents";
import { useConversationContext } from "../../../context/ChatContext/contextConvo";
import { selectChatMembersOnChat } from "../../../redux/slices/chatNSlice";
import { nebulaChatApi } from "../../../redux/services/nebulaChat";

interface ChatSettingsAddUsersProps {
    setSideBarTab: (val: ChatSettingsSidebarMenus) => void;
}

export const ChatSettingsAddUsers: React.FC<ChatSettingsAddUsersProps> = ({ setSideBarTab }) => {
    const { conversation } = useConversationContext();

    const participantUuidDict = useTypedSelector(state => Object.fromEntries((selectChatMembersOnChat(state, conversation.uuid) || []).map(u => [u.member, true])));

    const [searchTerm, setSearchTerm] = useState<string>('');

    const inputRef = useRef<HTMLInputElement>(null);

    const dispatch = useTypedDispatch()
    const { t } = usePolyglot();

    const usersForGroupSelection = useTypedSelector(state => state.chat.usersForGroupSelection);

    const [channelAction] = nebulaChatApi.endpoints.channelActionN.useMutation();


    const handleAddMembers = () => {
        const additionUsers = usersForGroupSelection.filter(u => !participantUuidDict[u.uuid]);

        if (additionUsers.length > 0) {
            channelAction({
                action: 'invite_members',
                users: additionUsers.map(m => m.uuid),
                channel_uuid: conversation.uuid
            })
            dispatch(setChannelCreation(false));
            dispatch(resetUsersForChannelSelection())
            setSideBarTab('menu')
        }
    }

    const handleGroupSelection = (usr) => {
        const groupSelectParams = {
            uuid: usr.uuid,
            image: usr.avatar_key,
            display_name: usr.nickname
        }
        inputRef.current?.focus()
        dispatch(setSingleUserForChannelSelection(groupSelectParams));
        setSearchTerm('')
    }

    return (
        <motion.div
            className={styles.chat_settings_page}
            initial={{
                opacity: 0,
            }}
            animate={{
                opacity: 1,
            }}
            exit={{
                opacity: 0,
            }}
        >
            <div className={styles.header}>
                <StyledButton
                    buttonStyle='text'
                    iconOnly
                    size='medium'
                    onClick={() => {
                        setSideBarTab('menu')
                        dispatch(resetUsersForChannelSelection())
                    }}
                    title='Return to settings menu'
                >
                    <Icon name='arrowLeft' ariaHidden />
                </StyledButton>
                <h4>{t("actions.add_user", 2)}</h4>
                {usersForGroupSelection.length > 0 &&
                    <StyledButton
                        buttonStyle='primary'
                        onClick={handleAddMembers}
                        className='overview__save-button'
                    >
                        <p>{t("actions.save")}</p>
                    </StyledButton>
                }
            </div>
            {usersForGroupSelection.length > 0 &&
                <ul className={styles.selected_users}>
                    {usersForGroupSelection?.map((usr, index) => (
                        <li key={index}>
                            <p>{usr.display_name}</p>
                            <StyledButton
                                buttonStyle='text'
                                iconOnly
                                onClick={() => handleGroupSelection(usr)}
                                size='small'
                            >
                                <Icon name='cross' width={13} height={13} />
                            </StyledButton>
                        </li>
                    ))}
                </ul>
            }
            <div
                className={styles.input_container}
                onClick={() => {
                    inputRef.current?.focus()
                }}
            >
                <Icon name='search' ariaHidden />
                <input
                    name='contacts Search'
                    placeholder={t("actions.search_contacts")}
                    value={searchTerm}
                    ref={inputRef}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
            <ContactsSearch
                searchTerm={searchTerm}
                handleSelect={handleGroupSelection}
                excluded={participantUuidDict}
            />
        </motion.div>
    )
}
